// extracted by mini-css-extract-plugin
export default {"container":"LH-z","innerContainer":"MH-z","multipleLines":"NH-z","heading":"OH-z","content":"PH-z","linkColor":"QH-z"};